/* eslint-disable react-hooks/rules-of-hooks */
import { ProjectAPI } from "@radarly/api/project";
import { PicturesUsage } from "@radarly/models/picture";
import { BlockedAuthors } from "@radarly/models/project";
import { CreateProjectUser } from "@radarly/models/user";
import { useProject } from "../context";
import { ProjectRepo } from "./ProjectRepo";

interface Dependencies {
  projectAPI: ProjectAPI;
}

export class ConnectedProjectRepo implements ProjectRepo {
  private projectAPI: ProjectAPI;
  public constructor(dependencies: Dependencies) {
    this.projectAPI = dependencies.projectAPI;
  }
  async contactProjectManager(project: number, subject: string, text: string) {
    return await this.projectAPI.contactProjectManager(project, subject, text);
  }
  getCurrentProject() {
    return useProject();
  }
  async getProject(project: number) {
    return await this.projectAPI.getProject(project);
  }

  generateProjectPictureUrl(project: number, picture: number) {
    return this.projectAPI.generateProjectPictureUrl(project, picture);
  }
  public async getProjectPicturesUsage(
    project: number
  ): Promise<PicturesUsage> {
    return await this.projectAPI.getProjectPicturesUsage(project);
  }

  public async getProjectBlockedAuthors(
    project: number
  ): Promise<BlockedAuthors> {
    return await this.projectAPI.getProjectBlockedAuthors(project);
  }

  public async removeUser(project: number, userId: number): Promise<void> {
    return await this.projectAPI.removeUser(project, userId);
  }
  public async removeUsers(
    project: number,
    usersId: number[]
  ): Promise<PromiseSettledResult<void>[]> {
    return await this.projectAPI.removeUsers(project, usersId);
  }

  public async createProjectUser(project: number, user: CreateProjectUser) {
    return this.projectAPI.createProjectUser(project, user);
  }

  public async getWeiboStatus() {
    return this.projectAPI.getWeiboStatus();
  }
}
